import { defineMessages } from 'react-intl';
import { SortingOptions } from '@zocdoc/branding/constants';

export const LOCALIZED_STRINGS = defineMessages({
    MoreFiltersTitle: {
        id: 'Search.Components.FacetedSerch.MoreFilters.Title',
        defaultMessage: 'more filters',
    },
    SortingDropdownTitle: {
        id: 'Search.Components.FacetedSearch.SortingDropdown.Title',
        defaultMessage: 'sort by:',
    },
});

export const SortingEnum = {
    [SortingOptions.Availability]: {
        name: 'onlinebookability',
        value: 'OnlineBookability',
        text: 'availability',
    },
    [SortingOptions.Default]: {
        name: 'default',
        value: 'Default',
        text: 'default order',
    },
    [SortingOptions.Distance]: {
        name: 'distance',
        value: 'Distance',
        text: 'distance',
    },
    [SortingOptions.WaitTime]: {
        name: 'waittime',
        value: 'WaitTimeRating',
        text: 'wait time rating',
    },
};

export const DefaultTexts = {
    sortType: SortingEnum[SortingOptions.Default].text,
};

export const DefaultValues = {
    sortType: SortingEnum[SortingOptions.Default].value,
};
